import React, { useState, useEffect } from "react";
import {
  Col,
  Nav,
  NavLink,
  TabContent,
  TabPane,
  Card,
  NavItem,
  CardBody,
} from "reactstrap";
import classnames from "classnames";
import { getUserRoles } from "../../../api/User/UserApi.js";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../ExtraPages/firebaseConfig";
import BoatOwnerForm from "./BoatOwnerForm";
import PlantOwnerForm from "./PlantOwnerForm";
import BuyerForm from "./BuyerForm";
import CourierForm from "./CourierForm";
import Overview from "./Overview";

const RightSideContent = ({
  profileData,
  onPercentageChange,
  onProfileDataChange,
}) => {
  const [activeTab, setActiveTab] = useState("1");
  const [userRoles, setUserRoles] = useState(null);
  const [completionPercentage, setCompletionPercentage] = useState(0);

  useEffect(() => {
    const fetchUserRoles = async (id) => {
      try {
        const response = await getUserRoles(id);
        console.log("roles", response.data.role);
        setUserRoles(response.data.role);
      } catch (error) {
        console.error("Error fetching user roles:", error);
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // console.log('user', user.uid);
      if (user) {
        fetchUserRoles(user.uid);
      }
    });

    return () => unsubscribe();
  }, []);

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handlePercentageChange = (percentage) => {
    setCompletionPercentage(percentage);
    if (onPercentageChange) {
      onPercentageChange(percentage);
    }
  };

  const setProfileData = (data) => {
    onProfileDataChange(data);
  };

  return (
    <React.Fragment>
      <Col lg={6}>
        <Card
          className="profile-content-page mt-4 mt-lg-0 shadow-lg"
          style={{ height: "600px", overflowY: "scroll", padding: "10px" }}
        >
          <Nav
            className="profile-content-nav nav-pills border-bottom mb-4"
            id="pills-tab"
            role="tablist"
            style={{ paddingBottom: "30px" }}
          >
            <NavItem role="presentation">
              <NavLink
                to="#"
                className={classnames({ active: activeTab === "1" })}
                onClick={() => tabChange("1")}
                type="button"
              >
                Overview
              </NavLink>
            </NavItem>
            {userRoles === "boat_owner" && (
              <NavItem role="presentation">
                <NavLink
                  to="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => tabChange("2")}
                  type="button"
                >
                  Boat Owner
                </NavLink>
              </NavItem>
            )}
            {userRoles === "processing_plant" && (
              <NavItem role="presentation">
                <NavLink
                  to="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => tabChange("2")}
                  type="button"
                >
                  Processing Plant
                </NavLink>
              </NavItem>
            )}
            {userRoles === "buyer" && (
              <NavItem role="presentation">
                <NavLink
                  to="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => tabChange("2")}
                  type="button"
                >
                  Buyer
                </NavLink>
              </NavItem>
            )}
            {userRoles === "courier" && (
              <NavItem role="presentation">
                <NavLink
                  to="#"
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => tabChange("2")}
                  type="button"
                >
                  Courier
                </NavLink>
              </NavItem>
            )}
          </Nav>

          <CardBody className="p-4">
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Overview onPercentageChange={handlePercentageChange} />
              </TabPane>
              {userRoles === "boat_owner" && (
                <TabPane tabId="2">
                  <BoatOwnerForm
                    profileData={profileData}
                    onProfileDataChange={setProfileData}
                    onPercentageChange={handlePercentageChange}
                  />
                </TabPane>
              )}
              {userRoles === "processing_plant" && (
                <TabPane tabId="2">
                  <PlantOwnerForm onPercentageChange={handlePercentageChange} />
                </TabPane>
              )}
              {userRoles === "buyer" && (
                <TabPane tabId="2">
                  <BuyerForm
                    profileData={profileData}
                    onProfileDataChange={setProfileData}
                    onPercentageChange={handlePercentageChange}
                  />
                </TabPane>
              )}
              {userRoles === "courier" && (
                <TabPane tabId="2">
                  <CourierForm onPercentageChange={handlePercentageChange} />
                </TabPane>
              )}
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default RightSideContent;
